export const DANGER_TYPE = 'danger';
